import {ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {LoggedInCallback} from '../../service-auth/cognito.service';
import {RoleChangeListener, StartupService} from '../../service-ui/startup.service';
import {MatSidenav} from '@angular/material/sidenav';
import {MediaMatcher} from '@angular/cdk/layout';
import {Subject} from 'rxjs';

/**
 * Facility-role landing page that hosts the per-facility rate-configuration editor.
 *
 * The current facility is identified by `startupService.selectedRoleId`.
 * Editor mode is AUTHORITATIVE because facilities are leaf nodes — there is no
 * parent rate-config to inherit from at this level.
 */
@Component({
  selector: 'app-facility-settings',
  templateUrl: './facility-settings.component.html',
  styleUrls: ['./facility-settings.component.css']
})
export class FacilitySettingsComponent implements OnDestroy, OnInit, LoggedInCallback, RoleChangeListener {
  @ViewChild('mainSideNav', {static: true}) mainSideNav: MatSidenav;
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  onDestroySubject: Subject<boolean> = new Subject();

  constructor(
    public router: Router,
    public startupService: StartupService,
    public changeDetectorRef: ChangeDetectorRef,
    public media: MediaMatcher
  ) {
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addEventListener('change', this._mobileQueryListener);
  }

  ngOnInit() {
    this.startupService.isAuthenticated(this);
  }

  ngOnDestroy() {
    this.onDestroySubject.next(true);
    this.mobileQuery.removeEventListener('change', this._mobileQueryListener);
  }

  isLoggedIn(message: string, isLoggedIn: boolean) {
    if (!isLoggedIn) {
      this.router.navigate(['/home/login']);
    }
  }

  roleChanged(role: string, roleId: string) {}

  /** Numeric facility ID (selectedRoleId is a string in StartupService). */
  get facilityId(): number {
    const id = this.startupService.selectedRoleId;
    return id ? Number(id) : 0;
  }
}

